import { Input } from '../../cars/components/V3/_shared/Form/Input'
import { SearchIcon } from '../../cars/components/V3/SearchIcon'

type SearchProps = {
  value: string
  onChange: (e: string) => void
}

export const Search = ({ onChange, value }: SearchProps) => {
  return (
    <div className="w-full relative">
      <Input
        id="search"
        value={value}
        className="pl-12"
        placeholder="Søk etter ansatt"
        onChange={(e) => onChange(e.target.value)}
      />
      <div className="absolute top-[12px] left-[14px]">
        <SearchIcon />
      </div>
    </div>
  )
}
